import { createI18n } from 'vue-i18n';
import en from './config/en';
import zh from './config/zh';



// const messages: any = {};
// lang.keys().forEach(key => {
//     const val = lang(key).default;
//     const name = key.replace(/(.*\/)*([^.]+).*/ig, '$2');
//     messages[name] = val;
// });


const   I18n = createI18n({
  locale: 'zh',
  messages:{
    'zh':zh,
    'en':en,
  },
});

export default I18n;